function reytelBalticUiText(source) {
  const copy = {"lt":{"Please select a rating.":"Pasirinkite įvertinimą.","Title is too short.":"Antraštė per trumpa.","Description must be at least 10 characters.":"Atsiliepime turi būti bent 10 simbolių.","Name is required.":"Įrašykite vardą.","Invalid email address.":"Įveskite galiojantį el. pašto adresą.","Upload error":"Nepavyko įkelti failo."},"lv":{"Please select a rating.":"Izvēlieties vērtējumu.","Title is too short.":"Virsraksts ir pārāk īss.","Description must be at least 10 characters.":"Atsauksmei jābūt vismaz 10 rakstzīmes garai.","Name is required.":"Ievadiet vārdu.","Invalid email address.":"Ievadiet derīgu e-pasta adresi.","Upload error":"Neizdevās augšupielādēt failu."},"et":{"Please select a rating.":"Vali hinnang.","Title is too short.":"Pealkiri on liiga lühike.","Description must be at least 10 characters.":"Arvustus peab olema vähemalt 10 tähemärki pikk.","Name is required.":"Sisesta nimi.","Invalid email address.":"Sisesta kehtiv e-posti aadress.","Upload error":"Faili üleslaadimine ebaõnnestus."}};
  const locale = (document.documentElement.lang || "en").split("-")[0];
  return (copy[locale] && copy[locale][source]) || source;
}

var _functions = {},
	winWidth,
	popupTop;
let uploadedFiles = [];

jQuery(function ($) {
	("use strict");

	/* function on page ready */
	var isTouchScreen =
		navigator.userAgent.match(/Android/i) ||
		navigator.userAgent.match(/webOS/i) ||
		navigator.userAgent.match(/iPhone/i) ||
		navigator.userAgent.match(/iPad/i) ||
		navigator.userAgent.match(/iPod/i);
	if (isTouchScreen) $("html").addClass("touch-screen");
	var winScr,
		winHeight,
		is_Mac = navigator.platform.toUpperCase().indexOf("MAC") >= 0,
		is_IE =
			/MSIE 9/i.test(navigator.userAgent) ||
			/rv:11.0/i.test(navigator.userAgent) ||
			/MSIE 10/i.test(navigator.userAgent) ||
			/Edge\/\d+/.test(navigator.userAgent),
		is_Chrome =
			navigator.userAgent.indexOf("Chrome") >= 0 &&
			navigator.userAgent.indexOf("Edge") < 0;

	/* check browser */
	winWidth = $(window).width();
	winHeight = $(window).height();

	if (is_Mac) {
		$("html").addClass("mac");
	}
	if (is_IE) {
		$("html").addClass("ie");
	}
	if (is_Chrome) {
		$("html").addClass("chrome");
	}

	_functions.scrollCall = function () {
		winScr = $(window).scrollTop();
	};

	// 🔧 Scroll control
	function removeScroll() {
		popupTop = $(window).scrollTop();
		$("html").css({
			position: "fixed",
			top: -popupTop,
			width: "100%",
		});
	}
	function addScroll() {
		$("html").css({ position: "static" });
		window.scroll(0, popupTop);
	}

	// 💥 Open popup with key
	_functions.openPopup = function (popupKey) {
		$(".popup-content").removeClass("active");
		$(".popup-content[data-rel='" + popupKey + "'], .popup-wrapper").addClass(
			"active",
		);

		removeScroll();
	};

	// ❌ Close popup
	_functions.closePopup = function () {
		$(".popup-wrapper, .popup-content").removeClass("active");
		addScroll();
	};

	// 🟢 Open trigger
	$(document).on("click", ".open-popup", function (e) {
		e.preventDefault();
		const popupKey = $(this).data("rel");
		_functions.openPopup(popupKey);
	});

	// 🔴 Close trigger
	$(document).on(
		"click",
		".popup-wrapper .btn-close, .popup-wrapper .layer-close, .popup-wrapper .close-popup",
		function (e) {
			e.preventDefault();
			_functions.closePopup();
		},
	);

	$(document).on("click", ".mobile-burger", function (e) {
		e.preventDefault();
		$(".menu").addClass("active");
	});
	$(document).on("click", ".menu .btn-close", function (e) {
		e.preventDefault();
		$(".menu").removeClass("active");
	});

	//FOOTER ACCORDEON
	function isMobile() {
		return $(window).width() <= 768;
	}

	$(".search-toggle").on("click", function (e) {
		e.preventDefault();
		$(".search-box").toggleClass("active");
	});

	$(document).on("click", function (e) {
		if (
			!$(e.target).closest(".search-box").length &&
			!$(e.target).closest(".search-toggle").length
		) {
			$(".search-box").removeClass("active");
		}
	});

	// Клік по тайтлу
	$(".accordion-mob__title").on("click", function () {
		if (!isMobile()) return;

		const parent = $(this).closest(".accordion-mob");
		const content = parent.find(".accordion-mob__content");

		parent.toggleClass("active");
		content.slideToggle(300);
	});

	// Обробка resize
	function handleResize() {
		if (isMobile()) {
			// Закриваємо все на мобілці
			$(".accordion-mob")
				.removeClass("active")
				.find(".accordion-mob__content")
				.hide();
		} else {
			// Відкриваємо все на десктопі
			$(".accordion-mob")
				.addClass("active")
				.find(".accordion-mob__content")
				.show();
		}
	}

	// Викликаємо при загрузці
	handleResize();

	// Викликаємо при resize
	$(window).on("resize", function () {
		handleResize();
	});

	$(document).on("click", "[data-stars] span", function () {
		const starValue = $(this).data("star");
		const container = $(this).parent();

		container.find("span").removeClass("active");

		for (let i = 1; i <= starValue; i++) {
			container.find(`[data-star="${i}"]`).addClass("active");
		}

		$("#rating-input").val(starValue);
	});

	//review form
	$("#submit-review").on("click", function () {
		const errors = [];
		const rating = $("#rating-input").val();
		const name = $("#review-name").val().trim();
		const email = $("#review-email").val().trim();
		const description = $("#review-description").val().trim();
		const title = $("#review-title").val().trim();

		if (!rating) errors.push(reytelBalticUiText("Please select a rating."));
		if (title.length < 3) errors.push(reytelBalticUiText("Title is too short."));
		if (description.length < 10)
			errors.push(reytelBalticUiText("Description must be at least 10 characters."));
		if (!name) errors.push(reytelBalticUiText("Name is required."));
		if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/))
			errors.push(reytelBalticUiText("Invalid email address."));

		if (errors.length) {
			$("#review-errors").html(errors.join("<br>"));
			$("#review-errors").slideDown();
			return;
		} else {
			$("#review-errors").slideUp();
		}

		// FormData for AJAX
		const formData = new FormData();
		formData.append("rating", rating);
		formData.append("title", title);
		formData.append("description", description);
		formData.append("name", name);
		formData.append("email", email);

		if (uploadedFiles.length) {
			uploadedFiles.forEach((file, i) => {
				if (file) formData.append("images[]", file);
			});
		}

		// TODO: AJAX endpoint
		console.log("Submitting review...", formData);
		resetReviewForm();
		// Close popup after success
		_functions.closePopup();
	});
	uploadFiles();

	$("#save-engraving").on("click", function (e) {
		e.preventDefault();

		const $form = $(this).closest("form");
		const errors = _functions.validateEngravingForm($form);

		_functions.showFormErrors(errors, $form);

		if (!errors.length) {
			const formEl = $form[0];
			if (formEl && typeof formEl.requestSubmit === "function") {
				formEl.requestSubmit();
			}
		}
	});

	_functions.showFormErrors = function (errors, $form) {
		const errorBox = $form.find(".form-error");

		if (!errors.length) {
			errorBox.hide().empty();
			return;
		}

		errorBox.html(errors.join("<br>")).slideDown();
	};

	_functions.validateEngravingForm = function ($form) {
		const errors = [];

		const requiredMsg =
			$form.data("error-required") ||
			"Please enter engraving text or upload an image.";

		const text = $form.find("#engraving-text").val()?.trim();
		const uploadedCount = $form.find(".upload-preview .preview-item").length;

		if (!text && uploadedCount === 0) {
			errors.push(requiredMsg);
		}

		return errors;
	};
});

function resetReviewForm() {
	// Inputs
	$("#review-title").val("");
	$("#review-description").val("");
	$("#review-name").val("");
	$("#review-email").val("");

	// Rating
	$("#rating-input").val("");
	$(".review-stars .star").removeClass("active");

	// Errors
	$("#review-errors").hide().empty();

	// Uploaded files reset
	uploadedFiles = [];

	// Preview reset
	$("#image-preview").empty();

	// Drop zone text reset
	$(".dropzone-text").show();

	// File input reset
	$("#review-image-input").val("");
}

$(function () {
	function updateHeaderSpacer() {
		var headerHeight = $(".header").outerHeight();
		if ($(window).width() <= 1055) {
			$(".header-spacer").height(headerHeight);
			$(".main-content +  nav").css("top", headerHeight + "px");
		}
	}

	// Викликаємо при завантаженні сторінки
	updateHeaderSpacer();

	// І при зміні розміру вікна
	$(window).on("resize", function () {
		updateHeaderSpacer();
	});
	$(document).ready(function () {
		updateHeaderSpacer();
	});
});
document.addEventListener("DOMContentLoaded", () => {
	const cardSliders = document.querySelectorAll(".product-card__inner-slider");

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (
					entry.isIntersecting &&
					!entry.target.classList.contains("swiper-initialized")
				) {
					new Swiper(entry.target, {
						slidesPerView: 1,
						// pagination: {
						//   el: entry.target.querySelector(".swiper-pagination"),
						//   clickable: true,
						//   dynamicBullets: true, // ✅ максимум 4 видимих точки
						// },
						navigation: {
							nextEl: entry.target.querySelector(".swiper-button-next"),
							prevEl: entry.target.querySelector(".swiper-button-prev"),
						},
						lazy: {
							loadPrevNext: true,
						},
					});

					entry.target.classList.add("swiper-initialized");
					observer.unobserve(entry.target);
				}
			});
		},
		{
			threshold: 0.2,
		},
	);

	cardSliders.forEach((slider) => observer.observe(slider));
});

document.querySelectorAll(".rating").forEach((r) => {
	const rating = parseFloat(r.dataset.rating);
	const activeStars = Math.round(rating);

	let html = "";

	for (let i = 0; i < 5; i++) {
		html += `
            <span>
                <img src="./img/icons/${
			i < activeStars ? "star-active" : "star"
		}.svg" alt="">
            </span>`;
	}
	html += `
            <span class="count">
               ${rating}
            </span>`;

	r.innerHTML = html;
});

$(document).ready(function () {
	const $selectWrapper = $(".custom-popover-select");

	// Якщо блоку немає — нічого не робимо
	if (!$selectWrapper.length) return;

	const $toggleBtn = $selectWrapper.find(".custom-popover-select__toggle");
	const $dropdown = $selectWrapper.find(".custom-popover-select__dropdown");
	const $label = $selectWrapper.find(".custom-popover-select__label");
	const $hiddenInput = $("#selected-size");

	const $tabs = $dropdown.find(".custom-popover-tab");
	const $contents = $dropdown.find(".custom-popover-content");
	const $rows = $dropdown.find(".custom-popover-row");

	// --- Open / close dropdown ---
	$toggleBtn.on("click", function (e) {
		e.stopPropagation();
		$selectWrapper.toggleClass("open");
	});

	// --- Close dropdown when clicking outside ---
	$(document).on("click", function (e) {
		if (!$(e.target).closest(".custom-popover-select").length) {
			$selectWrapper.removeClass("open");
		}
	});

	// --- Tabs switching ---
	$tabs.on("click", function () {
		const target = $(this).data("tab");

		$tabs.removeClass("active");
		$(this).addClass("active");

		$contents.removeClass("active");
		$("#tab-" + target).addClass("active");
	});

	// --- Selecting a size row ---
	$rows.on("click", function () {
		const value = $(this).data("value");
		const text = $(this)
			.find("span")
			.map(function () {
				return $(this).text().trim();
			})
			.get()
			.join("  ");

		// set label
		$label.text(text);

		// set input value
		if ($hiddenInput.length) {
			$hiddenInput.val(value);
		}

		// remove previous selections
		$rows.removeClass("selected");
		$(this).addClass("selected");

		// close
		$selectWrapper.removeClass("open");
	});
});

$(document).ready(function () {
	const $banner = $(".promo-banner");
	const $track = $(".promo-track");

	if (!$banner.length || !$track.length) return;

	const originalContent = $track.html();

	function fillTrack() {
		$track.html(originalContent);

		while ($track[0].scrollWidth < $banner.outerWidth() * 2) {
			$track.append(originalContent);
		}
	}

	fillTrack();

	$(window).on("resize", function () {
		fillTrack();
	});

});


$(document).ready(function () {

	$(".accordeon-item__header").click(function () {
		const $header = $(this);
		const $item = $header.parent();
		const $content = $header.next(".accordeon-item__content");

		// Закриваємо всі інші
		$(".accordeon-item").not($item).removeClass("active");
		$(".accordeon-item__content").not($content).slideUp(200);

		const isOpening = !$item.hasClass("active");


		$item.toggleClass("active");
		setTimeout(() => {
			$content.slideToggle(300, function () {
				if (isOpening && window.innerWidth <= 768) {
					const offset = 56;
					const top = $header.offset().top - offset;

					$("html, body").animate({ scrollTop: top }, 300);
				}
			});
		}, 200);
	});

	catalogFilters();

	const modal = $(".modal-filter");
	const closeModal = $(".modal-filter .btn-close");

	$(".open-popup-filter").on("click", function (e) {
		e.preventDefault();
		modal.addClass("active");
	});

	closeModal.on("click", function () {
		modal.removeClass("active");
	});

	$(".mobile-button").click(function () {
		$(this).toggleClass("active");
		$(".header nav").toggleClass("active");
		$(".header-navigation li").removeClass("active");
		if ($(window).width() <= 1055) {
			$("html").toggleClass("overflow-menu");
		}
	});
	$(".header-navigation > li > a").click(function (e) {
		if (
			$(window).width() <= 1055 &&
			$(this).closest("li").find(".sub-menu").length
		) {
			e.preventDefault();
			$(this).closest("li").addClass("active");
		}
	});
	$(".sub-menu__header").click(function (e) {
		e.preventDefault();
		$(this).closest("li").removeClass("active");
	});

	initHeroSlider();
	initProductsSlider();
});

$(document).ready(function () {
	$(".js-article-toggle").on("click", function (e) {
		e.preventDefault();

		const $btn = $(this);
		const $content = $btn
			.closest(".article-second")
			.find(".article-second__content");

		$content.toggleClass("active");

		// змінюємо текст кнопки
		if ($content.hasClass("active")) {
			$btn.text($btn.data("text-close"));
		} else {
			$btn.text($btn.data("text-open"));
		}
	});
});

function initProductsSlider() {
	$(".product-cards__slider").each(function () {
		const $this = $(this);

		const swiper = new Swiper(this, {
			slidesPerView: 1.4,
			spaceBetween: 6,
			navigation: {
				nextEl: $this
					.closest(".product-cards__wrapper")
					.find(".swiper-button-next")
					.get(0),
				prevEl: $this
					.closest(".product-cards__wrapper")
					.find(".swiper-button-prev")
					.get(0),
			},
			pagination: {
				el: $this.children(".swiper-pagination").get(0),
				clickable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 2.5,
					spaceBetween: 16,
				},
				1024: {
					slidesPerView: 4,
					spaceBetween: 24,
				},
			},
		});
	});
}

function initHeroSlider() {
	let mainSwiper = null;
	let thumbsSwiper = null;
	const heroSlider = document.querySelector(".hero-slider");
	const heroThumbs = document.querySelector(".hero-slider__thumbs");

	if (!heroSlider || !heroThumbs) return;

	function hydrateDeferredHeroImages() {
		const deferredImages = heroSlider.querySelectorAll("img[data-hero-src]");
		const pendingImages = [];

		deferredImages.forEach((image) => {
			image.loading = "eager";
			if (image.dataset.heroSrcset) image.srcset = image.dataset.heroSrcset;
			image.src = image.dataset.heroSrc;
			image.removeAttribute("data-hero-src");
			image.removeAttribute("data-hero-srcset");

			if (!image.complete) {
				pendingImages.push(new Promise((resolve) => {
					image.addEventListener("load", resolve, { once: true });
					image.addEventListener("error", resolve, { once: true });
				}));
			}
		});

		return Promise.all(pendingImages);
	}

	let autoplayStarted = false;
	function startHeroAutoplay() {
		if (autoplayStarted || !mainSwiper || mainSwiper.destroyed) return;
		autoplayStarted = true;
		hydrateDeferredHeroImages().finally(() => {
			if (mainSwiper && !mainSwiper.destroyed && mainSwiper.autoplay) {
				mainSwiper.autoplay.start();
			}
		});
	}

	function initSwiper() {
		// Тумбси (максимум 4)
		thumbsSwiper = new Swiper(heroThumbs, {
			slidesPerView: 4,
			spaceBetween: 8,
			watchSlidesProgress: true,
			slideToClickedSlide: true,
			centeredSlides: false,
			centerInsufficientSlides: false,
			loop: true,
		});

		// Основний слайдер
		mainSwiper = new Swiper(heroSlider, {
			slidesPerView: 1,
			spaceBetween: 8,
			loop: true,
			autoplay: {
				delay: 4000,
				disableOnInteraction: false,
			},
			thumbs: {
				swiper: thumbsSwiper,
			},
		});
		if (mainSwiper.autoplay) mainSwiper.autoplay.stop();
	}

	initSwiper();

	["pointerenter", "pointerdown", "touchstart", "focusin"].forEach((eventName) => {
		heroSlider.addEventListener(eventName, startHeroAutoplay, { once: true, passive: true });
	});

	const scheduleIdleAutoplay = () => {
		if ("requestIdleCallback" in window) {
			window.requestIdleCallback(startHeroAutoplay, { timeout: 8000 });
		} else {
			window.setTimeout(startHeroAutoplay, 4000);
		}
	};

	if (document.readyState === "complete") {
		scheduleIdleAutoplay();
	} else {
		window.addEventListener("load", scheduleIdleAutoplay, { once: true });
	}
}

function uploadFiles() {
	// У кожного upload-блоку буде свій масив файлів
	const uploadInstances = new Map();

	// Ініціалізація всіх блоків
	function initUploaders() {
		$(".upload-area").each(function () {
			const area = $(this);
			const input = area.find(".upload-input");
			const preview = area.closest(".form-group").find(".upload-preview");

			uploadInstances.set(area[0], {
				files: [],
				area,
				input,
				preview,
			});

			// ============================
			// FILE SELECT (click upload)
			// ============================
			area.find(".upload-trigger").on("click", () => input.trigger("click"));

			input.on("change", function () {
				handleFiles(area, this.files);
			});

			// ============================
			// DRAG & DROP
			// ============================
			area.on("dragover", function (e) {
				e.preventDefault();
				area.addClass("dragover");
			});

			area.on("dragleave", function () {
				area.removeClass("dragover");
			});

			area.on("drop", function (e) {
				e.preventDefault();
				area.removeClass("dragover");

				let dt = e.originalEvent.dataTransfer;
				if (dt && dt.files.length) handleFiles(area, dt.files);
			});
		});
	}

	// ============================
	// HANDLE FILES FOR INSTANCE
	// ============================
	// function handleFiles(area, files) {
	//   const inst = uploadInstances.get(area[0]);

	//   for (let file of files) {
	//     // Валідація типу
	//     if (!file.type.match("image.*")) {
	//       showUploadError(area, "File must be an image");
	//       continue;
	//     }

	//     // Валідація розміру ≤ 15MB
	//     if (file.size > 15 * 1024 * 1024) {
	//       showUploadError(area, "Maximum file size is 15 MB");
	//       continue;
	//     }

	//     let index = inst.files.push(file) - 1;
	//     addPreview(inst, file, index);
	//   }
	// }

	function handleFiles(area, files) {
		const inst = uploadInstances.get(area[0]);
		const maxFiles = parseInt(area.data("max-files"), 10) || Infinity;

		let currentCount = inst.files.filter((f) => f !== null).length;

		for (let file of files) {
			// ⛔ ліміт
			if (currentCount >= maxFiles) {
				showUploadError(area, getUploadError(area, "limit", { max: maxFiles }));
				break;
			}

			// ⛔ тип
			if (!file.type.match("image.*")) {
				showUploadError(area, getUploadError(area, "type"));
				continue;
			}

			// ⛔ розмір
			if (file.size > 15 * 1024 * 1024) {
				showUploadError(area, getUploadError(area, "size"));
				continue;
			}

			inst.files.push(file);
			addPreview(inst, file, inst.files.length - 1);
			currentCount++;
		}
	}

	// ============================
	// PREVIEW
	// ============================
	function addPreview(inst, file, index) {
		const reader = new FileReader();

		reader.onload = function (e) {
			const preview = `
      <div class="preview-item" data-index="${index}">
        <img src="${e.target.result}">
        <div class="preview-remove">×</div>
      </div>
    `;

			inst.preview.append(preview);
		};

		reader.readAsDataURL(file);
	}

	// ============================
	// REMOVE FILE
	// ============================
	$(document).on("click", ".preview-remove", function () {
		const item = $(this).closest(".preview-item");
		const index = item.data("index");

		// Який upload-area?
		const previewBox = item.closest(".upload-preview");
		const area = previewBox.closest(".form-group").find(".upload-area")[0];

		const inst = uploadInstances.get(area);

		inst.files[index] = null;
		item.remove();
	});

	// ============================
	// ERROR MESSAGE (inline)
	// ============================
	function showUploadError(area, message) {
		let err = area.closest(".form-group").find(".upload-error");

		if (!err.length) {
			err = $('<div class="upload-error"></div>');
			area.closest(".form-group").append(err);
		}

		err.text(message).slideDown();

		setTimeout(() => err.slideUp(), 4000);
	}

	// Запускаємо
	initUploaders();
}

function getUploadError(area, type, vars = {}) {
	let msg = area.data(`error-${type}`) || reytelBalticUiText("Upload error");

	Object.keys(vars).forEach((key) => {
		msg = msg.replace(`{${key}}`, vars[key]);
	});

	return msg;
}

function catalogFilters() {
	const $selectedFilters = $(".catalog-filter__bottom .selected-filters");
	const $bottom = $(".catalog-filter__bottom");

	function handleSelectedFilters() {
		const isMobile = window.innerWidth <= 768;

		if (isMobile) {
			// remove only visually — detach keeps events/data
			if ($selectedFilters.parent().length) {
				$selectedFilters.detach();
			}
		} else {
			// return back inside bottom block if not already there
			if (!$selectedFilters.parent().length) {
				$bottom.prepend($selectedFilters);
			}
		}
	}

	// Initial
	handleSelectedFilters();

	// On resize
	$(window).on("resize", handleSelectedFilters);

	// --------------------------------
	// 🔥 Функція оновлення мобільного UI
	// --------------------------------
	function updateMobileFiltersUI() {
		const selectedCount = $(".selected-tag").length;

		if (selectedCount > 0) {
			$(".modal-filter__header .count").addClass("active");
			$(".selected-filters").addClass("active");
		} else {
			$(".modal-filter__header .count").removeClass("active");
			$(".selected-filters").removeClass("active");
		}

		const baseTitle = document.querySelector('.catalog-filters')?.dataset.filterLabel || 'Filters';
		$(".modal-filter__header-title").text(
			selectedCount > 0 ? `${baseTitle} (${selectedCount})` : baseTitle,
		);
	}

	// --------------------------------
	// Dropdown open/close
	// --------------------------------
	$(".filter-toggle").on("click", function (e) {
		e.stopPropagation();
		const isMobile = window.innerWidth <= 768;
		const dropdown = $(this).next(".filter-dropdown");

		if (!isMobile) {
			$(".filter-dropdown").not(dropdown).hide();
			$(".filter-toggle").not(this).removeClass("active");
		}

		$(this).toggleClass("active");
		dropdown.toggle();
	});

	$(".filter-dropdown").on("click", function (e) {
		e.stopPropagation();
	});

	$(document).on("click", function () {
		$(".filter-dropdown").hide();
		$(".filter-toggle").removeClass("active");
	});

	// --------------------------------
	// Checkbox -> Add/Remove selected tag
	// --------------------------------
	$('input[type="checkbox"]').on("change", function () {
		const value = $(this).data("value");
		const label = value;
		const isMobile = window.innerWidth <= 768;
		const iconSrc = isMobile ? window.themeIcons.closeWhite : window.themeIcons.remove;
		const removeLabel = document.querySelector('.catalog-filters')?.dataset.removeLabel || 'Remove';
		if (this.checked) {
			$(".selected-filters").append(`
        <div class="selected-tag" data-value="${value}">
						${label} <span class="remove-tag" role="button" aria-label="${removeLabel}: ${label}"><img src="${iconSrc}" alt=""></span>
        </div>
      `);
		} else {
			$(`.selected-tag[data-value='${value}']`).remove();
		}

		updateMobileFiltersUI();
	});

	// --------------------------------
	// Remove tag manually
	// --------------------------------
	$(document).on("click", ".remove-tag", function () {
		const value = $(this).parent().data("value");

		$(`input[data-value='${value}']`).prop("checked", false);
		$(this).parent().remove();

		updateMobileFiltersUI();
	});

	// --------------------------------
	// Clear All
	// --------------------------------
	$(".clear-btn").on("click", function () {
		$('input[type="checkbox"]').prop("checked", false);
		$(".selected-filters").empty();

		updateMobileFiltersUI();
	});

	// --------------------------------
	// Price Range (noUiSlider)
	// --------------------------------
	// if (typeof noUiSlider === "undefined") return;
	//
	// $(".price-slider").each(function () {
	// 	const sliderComponent = $(this);
	// 	const minInput = sliderComponent.find(".min-price");
	// 	const maxInput = sliderComponent.find(".max-price");
	// 	const track = sliderComponent.find(".range-track")[0];
	//
	// 	if (!track) return;
	//
	// 	const minVal = parseInt(minInput.data("min"));
	// 	const maxVal = parseInt(maxInput.data("max"));
	//
	// 	// Create slider
	// 	noUiSlider.create(track, {
	// 		start: [minVal, maxVal],
	// 		connect: true,
	// 		range: { min: minVal, max: maxVal },
	// 	});
	//
	// 	// Update inputs when slider is moved
	// 	track.noUiSlider.on("update", function (values) {
	// 		minInput.val(Math.round(values[0]));
	// 		maxInput.val(Math.round(values[1]));
	// 	});
	//
	// 	// Update slider when inputs are changed manually
	// 	minInput.on("change", function () {
	// 		track.noUiSlider.set([this.value, null]);
	// 	});
	//
	// 	maxInput.on("change", function () {
	// 		track.noUiSlider.set([null, this.value]);
	// 	});
	// });
}

$(document).ready(function () {
	// --------------------------------
	// SORT dropdown
	// --------------------------------
	$(".filters-right .filter-dropdown label").on("click", function () {
		const value = $(this).data("value") || $(this).text().trim();
		const text = $(this).text().trim();

		$(this).closest(".filter-item").find(".sort-input").val(value);

		$(this)
			.closest(".filter-item")
			.find(".filter-toggle")
			.html(
				`${document.querySelector('.catalog-filters')?.dataset.sortLabel || 'Sort by'}: <span>${text}</span> <img src="./img/icons/caret-down-black.svg" alt="">`,
			);

		$(this).parent().hide();
	});

	$(".instagram-box").each(function () {
		const $box = $(this);
		const sliderEl = $box.find(".instagram-box__slider")[0];

		const nextEl = $box.find(".swiper-button-next")[0];
		const prevEl = $box.find(".swiper-button-prev")[0];

		new Swiper(sliderEl, {
			slidesPerView: 1,
			spaceBetween: 0,

			breakpoints: {
				768: {
					slidesPerView: 1.04,
					spaceBetween: 0,
				},
			},

			navigation: {
				nextEl: nextEl,
				prevEl: prevEl,
			},

			loop: false,
		});
	});
});

$(document).ready(function () {
	if (window.innerWidth > 768) return;

	let lastScroll = window.scrollY;
	const threshold = 65;
	const minDelta = 20;
	const header = $("header");

	$(window).on("scroll", function () {
		const currentScroll = window.scrollY;
		const delta = currentScroll - lastScroll;

		if (Math.abs(delta) < minDelta) return;

		if (delta > threshold) {
			header.addClass("scrolled-down");
			lastScroll = currentScroll;
		}

		if (delta < -threshold) {
			header.removeClass("scrolled-down");
			lastScroll = currentScroll;
		}
	});
});


$(document).ready(function () {
	// ---------------- Masonry init for visible grids ----------------
	function initMasonry($grid) {
		if ($grid.data("masonry-initialized")) return; // вже інітнули

		$grid.masonry({
			itemSelector: ".review-card",
			columnWidth: ".review-card",
			gutter: 24,
			percentPosition: true,
		});

		// якщо є фото
		if ($.fn.imagesLoaded) {
			$grid.imagesLoaded().progress(function () {
				$grid.masonry("layout");
			});
		}

		$grid.data("masonry-initialized", true);
	}

	// Ініт тільки для активних табів при завантаженні
	$(".tab-content.active .reviews-grid").each(function () {
		initMasonry($(this));
	});

	// ---------------- Tabs switching ----------------
	$(".tab-btn").on("click", function () {
		var tab = $(this).data("tab");

		// buttons active
		$(".tab-btn").removeClass("active");
		$(this).addClass("active");

		// content active
		$(".tab-content").removeClass("active");
		var $activeTab = $("#tab-" + tab).addClass("active");

		// ---- init or update Masonry for visible grids ----
		$activeTab.find(".reviews-grid").each(function () {
			var $grid = $(this);

			// Якщо не інітнуто — інітнемо
			if (!$grid.data("masonry-initialized")) {
				initMasonry($grid);
			} else {
				// якщо вже є — просто оновити layout
				setTimeout(function () {
					$grid.masonry("layout");
				}, 30);
			}
		});
	});

	function updateCartState() {
		const hasItems = $(".cart-item").length > 0;

		$(".cart-body, .cart-footer").toggle(hasItems);
		$(".cart-empty").toggle(!hasItems);
	}

	// open cart by data attribute
	$(document).on("click", "[data-open-cart]", function (e) {
		e.preventDefault();
		$(".cart-drawer, .cart-overlay").addClass("open");
		const popupKey = $(this).data("rel");
		_functions.openPopup(popupKey);
		updateCartState();
	});

	// close cart
	$(document).on("click", ".close-cart, .cart-overlay", function () {
		$(".cart-drawer, .cart-overlay").removeClass("open");
		_functions.closePopup();
	});

	// remove item
	$(document).on("click", ".remove-item", function () {
		$(this).closest(".cart-item").remove();
		updateCartState();
	});

	// qty buttons
	$(document).on("click", ".qty-plus", function () {
		const input = $(this).siblings("input");
		input.val(+input.val() + 1);
	});

	$(document).on("click", ".qty-minus", function () {
		const input = $(this).siblings("input");
		if (input.val() > 1) {
			input.val(+input.val() - 1);
		} else {
			$(this).closest(".cart-item").remove();
			updateCartState();
		}
	});

	updateCartState();
});

// $(document).ready(function () {
//   const $grid = $("#reviews-grid");

//   // якщо елемента нема — просто виходимо
//   if (!$grid.length) return;

//   // ініціалізація Masonry
//   $grid.masonry({
//     itemSelector: ".review-card",
//     columnWidth: ".review-card",
//     gutter: 24,
//     percentPosition: true,
//   });

//   // якщо підключений imagesLoaded — вмикаємо
//   if (typeof $.fn.imagesLoaded === "function") {
//     $grid.imagesLoaded().progress(function () {
//       $grid.masonry("layout");
//     });
//   }
// });
